/**
 * Helper to normalize a theme variable (defined in ems) against the applied
 * fontSize (also defined in ems), so that the resulting value renders correctly
 */
var getNormalizedValue = function getNormalizedValue(value, base) {
  return parseFloat(value) / parseFloat(base) + "em";
};

export default getNormalizedValue;